export const SettingsSectionLayout = ({
  title,
  description,
  children,
}: {
  title: string
  description: string
  children: React.ReactNode
}) => {
  return (
    <div className="">
      <div className="text-t100 mb-1 text-base leading-5">{title}</div>
      <div className="text-t200 mb-8 text-sm">{description}</div>
      {children}
    </div>
  )
}
